export const STATUS_INDEX = {
    UUID: 0,
    NAME: 1,
}

export const EARTHQUAKE_INDEX = {
    UUID: 0,
    NAME: 1,
    STATUS_UUID: 2,
    STATUS_NAME: 3,
    OCCURED_AT: 4,
    MAX_INTENSITY: 5,
    INSPECTIONS_NAME: 6,
}

export const intensityMap = {
    '震度なし': 0,
    '震度１': 1,
    '震度２': 2,
    '震度３': 3,
    '震度４': 4,
    '震度５弱': 5,
    '震度５強': 6,
    '震度６弱': 7,
    '震度６強': 8,
    '震度７': 9
};

export const inspectionPriorityMap = {
    '大分市新春日町': 1,
    '大分市野津原': 2,
    '由布市庄内町': 3
}

export const DAM_REPORT_STANDARD_INTENSITY = '震度４';
export const POWERPLANT_REPORT_STANDARD_INTENSITY = '震度５弱';